/* eslint-disable no-param-reassign */
import Papa from 'papaparse';

function fetchSpreadsheet(url, callback) {
  Papa.parse(url, {
    download: true,
    header: true,
    skipEmptyLines: true,
    complete(results) {
      const validData = results.data.filter(row => row.entranosite === 'x' || row.entranosite === 'TRUE');
      callback(validData);
    },
  });
}


export function fetchProjects(callback) {
  fetchSpreadsheet('https://docs.google.com/spreadsheets/d/e/2PACX-1vSBLvgJumFNuQ1mLrFH2-n-Kko9_PJHSBxa1jc-shc5WlaAhKHJe8gCpFmquxGLMfGRjk8N7v3-W5H0/pub?output=csv', callback);
}

export function fetchTRLInfo(callback) {
  fetchSpreadsheet('https://docs.google.com/spreadsheets/d/e/2PACX-1vTYn57j9Bt5Dc2k3qOKaOJqt-WQybRvFjYe3cWXW6b2Zm7DvFIr3rukOYixlaOpUjlhvJpj1sk-rOjN/pub?output=csv', callback);
}

export function fetchTeam(callback) {
  fetchSpreadsheet('https://docs.google.com/spreadsheets/d/e/2PACX-1vQpp-MMSSiuwuvjvjI0sdPX9pwOuGilQNoh8AYMRnmRs919PmMTSzkScrUdCA6u_BcizKqmLLhgm2yU/pub?output=csv', callback);
}

export function fetchPublications(callback) {
  fetchSpreadsheet('https://docs.google.com/spreadsheets/d/e/2PACX-1vSyY5FXMHpyuCWM730CWT1yogPr9D8KEAd2U1unMOmA4sfElWNL6EbVyAPUQ1NJLtY7yb6POZAM0TwY/pub?output=csv  ', callback);
}

export function fetchAwards(callback) {
  fetchSpreadsheet('https://docs.google.com/spreadsheets/d/e/2PACX-1vQept0AuqKpPpTYSHt8Uls-3ftuENTu9Dp5WMhDgLGi_F6g9qNH3ktaLrDGkdn7GdUPBRfvMsCxf-wm/pub?output=csv', callback);
}
